import React from 'react';
import { MdFiberManualRecord } from 'react-icons/md';

const StateTag = ({ disabled, position = 'center' }) => {
    const stateColor = disabled
        ? 'bg-gradient-to-r from-red-500 to-red-600 dark:from-red-600 dark:to-red-700'
        : 'bg-gradient-to-r from-green-400 to-green-500 dark:from-green-500 dark:to-green-600';

    const TagPosition = position === 'right' ? 'justify-end' : position === 'left' ? 'justify-start' : 'justify-center'

    const stateLabel = disabled ? 'Inactivo' : 'Activo';

    return (
        <div className={`flex ${TagPosition} items-center`}>
            <span className={`text-sm font-bold ${stateColor} text-white py-1 px-3 rounded-xl flex items-center gap-1`}>
                <MdFiberManualRecord className={`${disabled ? 'text-red-200' : 'text-green-200'}`} /> {stateLabel}
            </span>
        </div>
    );
};


export default StateTag;
